import { combineEpics } from 'redux-observable'
import { combineReducers } from 'redux'
import products, { epics } from './products'
import _ from 'lodash';
export const rootEpic = combineEpics.apply(this, _.toArray(epics))

export const rootReducer = combineReducers({
  products: products,
})
